const PREFIX = 'corecry:bot-preview:v1:';
const TTL = 24 * 60 * 60 * 1000;

export function readBotPreview(identity, { requireComplete = false } = {}) {
    if (!identity) return [];
    try {
        const value = JSON.parse(localStorage.getItem(PREFIX + identity) || 'null');
        if (!value || value.identity !== identity || !Array.isArray(value.bots) || !Number.isFinite(value.savedAt) ||
            Date.now() < value.savedAt || Date.now() - value.savedAt > TTL) return [];
        return value.bots.filter(bot => typeof bot.id === 'string' && typeof bot.name === 'string' && (!requireComplete ||
            (['dca', 'strategy'].includes(bot.basic?.botType) && ['spot', 'linear'].includes(bot.basic?.marketType) &&
            (bot.basic.botType !== 'dca' || ['signal', 'hybrid', 'alert_averaging', 'accumulation'].includes(bot.dca?.mode)))));
    } catch { return []; }
}

export function writeBotPreview(identity, bots) {
    if (!identity) return;
    try {
        const safe = bots.filter(bot => bot?.id != null).slice(0, 500).map(bot => ({
            id: String(bot.id), name: String(bot.botName || bot.name || 'Bot'),
            exchange: String(bot.exchange || ''),
            basic: { pair: String(bot.basic?.pair || bot.pair || ''), botType: String(bot.basic?.botType || ''),
                marketType: String(bot.basic?.marketType || bot.marketType || ''), tradeType: String(bot.basic?.tradeType || bot.type || bot.tradeType || ''),
                tradingMode: String(bot.basic?.tradingMode || ''), leverage: Number.isFinite(Number(bot.basic?.leverage ?? bot.leverage)) ? Number(bot.basic?.leverage ?? bot.leverage) : null },
            dca: { mode: String(bot.dca?.mode || '') }, simulation: { enabled: bot.simulation?.enabled === true },
            status: String(bot.status || ''), favorite: Boolean(bot.favorite),
        }));
        const value = JSON.stringify({ identity, savedAt: Date.now(), bots: safe });
        if (value.length <= 200000) localStorage.setItem(PREFIX + identity, value);
    } catch { /* Optional local presentation snapshot. */ }
}

export function clearBotPreviews() {
    try {
        for (let i = localStorage.length - 1; i >= 0; i--) {
            const key = localStorage.key(i);
            if (key?.startsWith(PREFIX)) localStorage.removeItem(key);
        }
    } catch { /* Storage is optional. */ }
}
